import React from "react";
import Input from "./Input";
import { StyledLabel } from "./ui";

const LabelInput = props => {
  const { label, half, inline, tight, Component = Input, ...rest } = props;
  return (
    <StyledLabel half={half} inline={inline} tight={tight}>
      <label>{label}</label>
      <Component inline={inline} {...rest} />
    </StyledLabel>
  );
};

export default LabelInput;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/LabelInput.js